import React, { forwardRef, useEffect, useRef } from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import { ExternalLink } from '../../external-link'
import constant from '../../../../common/constant'
export const TopNavMenuItem = forwardRef((props, ref) => {
  const { as = NavLink, children, active, ...rest } = props
  const linkRef = useRef(null)

  useEffect(() => {
    if (linkRef.current && active) {
      linkRef.current.focus()
    }
  }, [linkRef, active])

  const mergeRefs = ref ? ref : linkRef

  const Comp = as === 'a' ? ExternalLink : NavLink

  return (
    <Comp
      className="dev_dash__top-nav-menu-item"
      ref={mergeRefs}
      {...rest}
      data-dxa={`${constant.FPTI_PAGES_CATEGORIES.TOP_NAV},click,${children}`}
    >
      {children}
    </Comp>
  )
})

TopNavMenuItem.displayName = 'TopNavMenuItem'

TopNavMenuItem.propTypes = {
  as: PropTypes.any,
  children: PropTypes.any.isRequired,
  active: PropTypes.bool,
}
